import { Typography, Container, Button, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

const ContactUs = () => {
  const theme = useTheme();
  return (
    <Container maxWidth="md" style={{ marginTop: 50 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Contact Us
      </Typography>
      <br />
      <Divider />
      <br />
      <Typography variant="body1" align="center" paragraph>
        Feel free to get in touch with us. We are here to help!
      </Typography>

      <Typography variant="h6" gutterBottom>
        Call Us
      </Typography>
      <Typography variant="body1" paragraph>
        (+91) 74474 77868
      </Typography>

      <Typography variant="h6" gutterBottom>
        Email Us
      </Typography>
      <Link
        to="mailto:info@cctech.co.in"
        style={{
          color: `${theme.palette.primary.main}`,
          textDecoration: "none",
        }}
      >
        <Typography
          variant="body1"
          paragraph
        >
          info@cctech.co.in
        </Typography>
      </Link>

      <Typography variant="h6" gutterBottom>
        Visit Us
      </Typography>
      <Typography variant="body1" paragraph>
        403, Pushpak Business Hub, Wakad, Pune 411057, India
      </Typography>

      <Typography variant="h6" gutterBottom>
        Follow Us
      </Typography>
      <Button
        variant="outlined"
        color="primary"
        component={Link}
        to="https://www.linkedin.com/company/centre-for-compuational-technologies-cctech"
        target="_blank"
        rel="noopener"
      >
        LinkedIn
      </Button>
    </Container>
  );
};

export default ContactUs;
